import { DateTimeFormatOptions } from "../../Models/Classes";
import { GetDateTimeFormatOptions } from "./GetDateTimeFormatOptions";

export const FormatDateTime = (datetime: string, options: DateTimeFormatOptions = {}): string => {
    if (!datetime) return "";
    const myDate = new Date(datetime);
    const formatOptions = GetDateTimeFormatOptions(options);
    return new Intl.DateTimeFormat('it-IT', formatOptions).format(myDate);
}
